module.exports = __webpack_public_path__ + "static/media/moons_plan_de_tratamiento.5732b0ee.webp";